var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-caption grey--text text--darken-1",staticStyle:{"line-height":"15px"}},[_c('v-clamp',{attrs:{"autoresize":"","max-lines":2}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }